import { FC, useMemo } from 'react';

import { useCardOfferDataContext } from 'shared/context/CardContext';
import { useCAForCard } from 'shared/hooks/useCAForCard';
import { extractUndefined } from 'shared/utils/extractUndefined';

import { VASList } from './VASList';
import {
  getAuctionVasListItem,
  getPremiumVasListItem,
  getStandardVasListItem,
  getTop3VasListItem,
} from './internal/utils/getVasListItem';
import { VasListItem } from './types';

export const VASListContainer: FC = () => {
  const {
    extendedProperties: { offerServices, auction },
  } = useCardOfferDataContext();

  const caForCard = useCAForCard();

  const vasList = useMemo<VasListItem[]>(() => {
    const result = Array.of<VasListItem>();

    if (!offerServices) {
      return result;
    }

    const { isAuction, isPremium, isTop3, isStandard } = offerServices;

    if (isTop3) {
      result.push(getTop3VasListItem());
    }
    if (isPremium) {
      result.push(getPremiumVasListItem());
    }
    if (isStandard) {
      result.push(getStandardVasListItem());
    }
    if (isAuction) {
      result.push(getAuctionVasListItem(extractUndefined(auction?.vasTitle)));
    }

    return result;
  }, [auction, offerServices]);

  if (!vasList.length) {
    return null;
  }

  return (
    <VASList
      items={vasList}
      trackVasInfoClick={(): void => caForCard({ action: 'click_sopr', category: 'Listing', label: 'vas_info' })}
    />
  );
};
